import { t } from "../../utils/i18n";
import React from "react";

const Preview = ({
  fees,
  amount,
  netAmount,
  selectedCurrency,
  firstTimeWithdrawalFee,
  isFirstTimeWithdrawal,
}) => (
  <div className="preview-wrapper mt-md-3">
    <div className="d-flex flex-column flex-md-row justify-content-md-around bg-gray rounded-lg p-3">
      <div className="d-flex flex-column align-items-md-center mb-1 mb-md-0 ">
        <label className="form-label font-weight-bold mb-1">
          {t("transfers_send.common.amount")}
          <a
            data-toggle="tooltip"
            className="ml-1"
            data-original-title={t("transfers_send.common.tip_subtotal_period")}
          >
            <i className="fa fa-info-circle"></i>
          </a>
        </label>
        <p className="font-0_8 my-1 ml-0">
          {selectedCurrency}{" "}
          {parseFloat(amount || "0.00").toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      </div>

      <div className="d-flex flex-column align-items-md-center mb-1 mb-md-0 ">
        <label className="form-label font-weight-bold mb-1">
          {t("transfers_send.common.fee")}
          <a
            data-toggle="tooltip"
            className="ml-1"
            data-original-title={t("transfers_send.common.tip_fee")}
          >
            <i className="fa fa-info-circle"></i>
          </a>
        </label>
        <p className="font-0_8 my-1 ml-0">
          {selectedCurrency}{" "}
          {parseFloat(fees).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      </div>
      <div className="d-flex flex-column align-items-md-center mb-1 mb-md-0 ">
        <label className="form-label font-weight-bold mb-1 pr-0">
          {t("transfers_send.common.one_time_setup_fee")}
          <a
            data-toggle="tooltip"
            className="ml-1 pl-1 pr-0"
            data-original-title={t("transfers_send.common.tip_one_time_fee")}
          >
            <i className="fa fa-info-circle"></i>
          </a>
        </label>
        <p className="font-0_8 my-1 ml-0">
          {selectedCurrency}{" "}
          {parseFloat(firstTimeWithdrawalFee).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      </div>
      <div className="d-flex flex-column align-items-md-center mb-1 mb-md-0 ">
        <label className="form-label font-weight-bold mb-1">
          {t("transfers_send.common.total")}
          <a
            data-toggle="tooltip"
            className="ml-1"
            data-original-title={t("transfers_send.common.tip_total")}
          >
            <i className="fa fa-info-circle"></i>
          </a>
        </label>
        <p className="font-0_8 my-1 ml-0">
          {selectedCurrency}{" "}
          {parseFloat(netAmount).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      </div>
    </div>
  </div>
);

export default Preview;
